import React, { PropsWithChildren } from 'react';

import { ClassName } from '../utils';


export * from './Button';
export * from './CheckBox';
export * from './ClosingOverlay';
export * from './Icon';
export * from './FormControls';
export * from './Layout';
export * from './LoadingIndicator';
export * from './PdfContainer';
export * from './TabHeader';
export * from './Tooltip';
export * from './TransitionComponent';
export * from './Typography';
export * from './Slider';
export * from './Portal';
export * from './ProgressLoader';
export * from './Responsive';

export const UI2Migration = ({ children, className }: PropsWithChildren<ClassName>) =>
    React.createElement('div', { className, style: { fontFamily: 'Roboto, sans-serif' } }, children);
